import { isEqual } from "lodash";
import { getRouteLoaderParams } from "./getRouteLoaderParams";

/**
 * Determine whether navigation between two locations would cause a route-loader change.
 *
 * @param currentLocation - Current URL pathname.
 * @param nextLocation - Next URL pathname to compare.
 * @returns `true` when the route loader parameters differ, otherwise `false`.
 */
export const locationCheck = (currentLocation: string, nextLocation: string) => {
  const currentParams = getRouteLoaderParams(currentLocation);
  const targetParams = getRouteLoaderParams(nextLocation);
  const loaderChange = !isEqual(currentParams, targetParams);
  return loaderChange;
};
